var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgK(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48.8 52",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 52v-14.2h2.5v-19.1h-2.5v-13.61l5.1-5.09h43.7v13.53l-5.16 5.17h-4.25l-4.89 4.92 9.7 9.68h4.6v13.53l-5.16 5.17z",
    className: "cjd-border",
    fill: "#525a6f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m43.17 17.6 4.53-4.54v-11.96h-22.7v4.5h-.2v-4.5h-19.23l-4.47 4.46v12.04h2.5v21.3h-2.5v12h19.2v-4.5h.2v4.5h22.67l4.53-4.54v-11.96h-3.97l-10.84-10.78 6.03-6.02z",
    className: "cjd-stroke",
    fill: "#8089a2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m21.06 35.53h2.58v9.71h-17v-9.71h2.6v-23.59h-2.59v-9.71h17v9.71h-2.59v6.06l6.14-6.09h-1.13v-9.68h20.44v9.71h-3.51l-11.72 11.67 12 11.92h3.25v9.71h-20.46v-9.71h1.19l-4.19-4.13-2 2.07v2.06z",
    className: "cjd-fill",
    fill: "#f9fbfe"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgK);
export default __webpack_public_path__ + "static/media/k.7392b7211f8f3270c0b03ab308198ded.svg";
export { ForwardRef as ReactComponent };